import { useEffect, useRef, useState } from 'react'
import { Nav, NavItem, NavLink } from 'reactstrap'
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import { noop } from 'lodash';
import CreatorCard from 'Components/creator-marketplace/CreatorCard';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { searchCreators } from 'services/api/creator-marketplace';
import ifConfigured from 'hoc/ifConfigured';

const PER_PAGE = 10;

const CreatorMarketplace = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true)
    const [creators, setCreators] = useState<any>([])
    const [error, setError] = useState<any>(null);
    const [filters, setFilters] = useState<Record<string, any>>({});
    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);
    const [hasMore, setHasMore] = useState(true);

    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

    const search = (q: string) => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            if (q.trim().length > 3) {
                setFilters({ ...filters, query: q.trim(), page: 1 });
            } else if (q.trim().length === 0) {
                setFilters({ ...filters, query: '', page: 1 });
            }
        }, 500);
        setSearchQuery(q);
    }


    useEffect(() => {
        if (selectedAgencyId && filters.query) {
            setLoading(true);
            setInitialLoading(true);
            searchCreators(selectedAgencyId, filters).then((response) => {
                if (Array.isArray(response.items)) {
                    if ((filters.page ?? 1) > 1) {
                        setCreators((prev: any) => [...prev, ...response.items]);
                    } else {
                        setCreators(response.items);
                    }
                }

                if((response.count ?? 0) < PER_PAGE){
                    setHasMore(false);
                }
                
            }).catch((err) => console.log(err)).finally(() => {
                setLoading(false);
                setInitialLoading(false);
            })
        }
    }, [filters, selectedAgencyId])

    return (
        <div>
            <div className="campaign-page">
                <h1 className="campaign-page-title">Creator Marketplace</h1>
                <div className="d-flex justify-content-between align-items-center campaign-page-info flex-column flex-lg-row mt-4 gap-2 gap-lg-0">
                    <Nav tabs className="nav nav-tabs nav-tabs-custom nav-primary nav-justified campaign-nav w-100 w-lg-50">
                        <NavItem className='campaign-nav-item'>
                            <NavLink
                                style={{ cursor: "pointer" }}
                                className={`campaign-nav-link active-campaign-nav text-start`}
                            >
                                Search
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <div className="d-flex justify-content-end align-items-center w-50 me-n1">
                        <div className="campaign-layout-search-container w-100 position-relative me-2">
                            <span>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.66732 14.0002C11.1651 14.0002 14.0007 11.1646 14.0007 7.66683C14.0007 4.16903 11.1651 1.3335 7.66732 1.3335C4.16951 1.3335 1.33398 4.16903 1.33398 7.66683C1.33398 11.1646 4.16951 14.0002 7.66732 14.0002Z" fill="#BBD8ED" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M15 16L12 13" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                            <input type="text" placeholder='Search by username or keyword' value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="campaign-layout-search-input w-100 me-2" />
                            {
                                searchQuery && (
                                    <span className="search-clear-icon" onClick={() => {
                                        setSearchQuery('');
                                    }}>
                                        <i className='bx bx-x' />
                                    </span>
                                )
                            }
                        </div>
                        <button onClick={() => {
                            setFilters({ ...filters, query: searchQuery.trim(), page: 1 });
                        }} className="btn btn-gradient">Search</button>

                    </div>
                </div>
                <div className="campaign-page-content my-3">
                    <InfiniteScroll
                        dataLength={creators.length + 1}
                        next={noop}
                        className='row g-3'
                        hasMore={hasMore}
                        loader={<></>}
                    >
                        {
                            !initialLoading && creators.map((creator: any, i: number) => <div key={i} className='col-xl-3 col-lg-4 col-md-6 col-sm-6 pe-1'><CreatorCard creator={creator} key={i} /></div>)
                        }
                        {
                            (loading) && Array.from({ length: 4 }).map((_, i) => (
                                <div key={i} className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                    <Skeleton height={336} className='w-100 d-block' />
                                </div>
                            ))
                        }
                        {
                            !(loading) && error &&
                            <div className="d-flex justify-content-center align-items-center">
                                <button className="theme-btn theme-btn-sm btn-primary-outlined" onClick={noop}>Load More <i className='ms-2 fs-5 bx bx-refresh'></i></button>
                            </div>
                        }
                        {
                            !(loading) && creators.length === 0 &&
                            <div className="d-flex w-100 justify-content-center align-items-center">
                                <div className="length-zero">
                                    <h3>Currently there is no creator in your list, try adjusting filters!</h3>
                                </div>
                            </div>
                        }
                    </InfiniteScroll>

                </div>
            </div>
        </div>
    )
}

export default ifConfigured(CreatorMarketplace, 'agency_ig_creator_marketplace')
